import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FaChevronDown, FaBars, FaTimes } from 'react-icons/fa';
import { useFetchWithCache } from '../hooks/useFetchWithCache';
import {
  HeaderWrap, TopStrip, Bar, Brand, Nav, NavLinkItem,
  DropdownWrap, DropdownBtn, DropdownMenu, DropdownLink,
  ContactCta, BurgerBtn,
} from './styles/Header.styles';

const Header = () => {
  const location = useLocation();
  const { data: companies } = useFetchWithCache('/companies');
  const { data: home } = useFetchWithCache('/home');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const sortedCompanies = Array.isArray(companies)
    ? [...companies]
        .filter(c => c && (c.isPublished === undefined || c.isPublished))
        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    : [];

  return (
    <HeaderWrap>
      <TopStrip>
        <div>
          <span>Ehcerex</span>
          <div>Group of Companies &middot; Liberia</div>
        </div>
      </TopStrip>
      <Bar>
        <Brand to="/" aria-label="Ehcerex">
          {home?.logo ? (
            <img className="logo" src={home.logo} alt="Ehcerex" />
          ) : (
            <div className="mark">E</div>
          )}
        </Brand>

        <Nav $open={menuOpen}>
          <NavLinkItem to="/" $active={isActive('/')}>Home</NavLinkItem>
          <NavLinkItem to="/about" $active={isActive('/about')}>About</NavLinkItem>

          <DropdownWrap ref={dropdownRef}>
            <DropdownBtn
              onClick={() => setDropdownOpen(o => !o)}
              aria-expanded={dropdownOpen}
              type="button"
            >
              Companies <FaChevronDown />
            </DropdownBtn>
            <DropdownMenu $open={dropdownOpen}>
              {sortedCompanies.length === 0 && (
                <div style={{ padding: '0.75rem 1.25rem', fontSize: '0.85rem', color: '#8A8A8A' }}>
                  No companies yet
                </div>
              )}
              {sortedCompanies.map(c => (
                <DropdownLink key={c.id || c.slug} to={`/companies/${c.slug}`}>
                  {c.menuLabel || c.title}
                </DropdownLink>
              ))}
            </DropdownMenu>
          </DropdownWrap>

          <NavLinkItem to="/team" $active={isActive('/team')}>Team</NavLinkItem>

          <ContactCta to="/contact">Contact</ContactCta>
        </Nav>

        <BurgerBtn onClick={() => setMenuOpen(o => !o)} aria-label="Toggle menu">
          {menuOpen ? <FaTimes /> : <FaBars />}
        </BurgerBtn>
      </Bar>
    </HeaderWrap>
  );
};

export default Header;
